import { render, staticRenderFns } from "./bankFileDiag.vue?vue&type=template&id=19b2dd34&"
import script from "./bankFileDiag.vue?vue&type=script&lang=js&"
export * from "./bankFileDiag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports